import { Card, CardBody, CardHeader } from "../../../components/card/card";
import { FaWhatsappSquare } from "react-icons/fa";
import { useState } from "react";
import { dataTel3PostSendLinksMessages } from "../../../config/apiSPA";
import ModalInfo from "../../../components/modal/modalInfo";
import Modal3InOne from "../../../components/modal/modal3inOne";
function ResumeContent({ id }) {
  const [modalWarningWa, setModalWarningWa] = useState(false);
  const [modalFailedWa, setModalFailedWa] = useState({ show: false, message: "" });
  const handleClickSendWa = () => {
    setModalWarningWa(true);
  };
  const handleClickContinue = async () => {
    await dataTel3PostSendLinksMessages({ mainId: id });
  };
  return (
    <>
      <Card className="mb-4">
        <CardHeader className="d-flex align-items-center fw-400 bg-inverse bg-opacity-10">
          <div className="flex-1">
            <div>Options</div>
          </div>
        </CardHeader>
        <CardBody>
          <span onClick={handleClickSendWa} role="button" className="btn btn-outline-theme me-2 mb-1 w-100 d-flex align-items-center justify-content-between">
            <div className="d-flex align-items-center gap-3 flex-grow-1">
              <div className="icon-box">
                <FaWhatsappSquare size={40} />
              </div>

              <div className="text-start">
                <div className="fw-semibold">Send links</div>
                <div className="small">Kirim semua link ke masing-masing Evaluator</div>
              </div>
            </div>

            <div className="text-white-50">&gt;</div>
          </span>
        </CardBody>
      </Card>
      <Modal3InOne
        onHide={() => setModalWarningWa(false)}
        show={modalWarningWa}
        title={"Send Link"}
        text={"Setelah anda click continue, maka system akan mengirim whatsapp blast ke masing-masing evaluator. pastikan nama-nama evaluator sudah benar."}
        onConfirm={handleClickContinue}
      />
      <ModalInfo show={modalFailedWa.show} clicked={() => setModalFailedWa((a) => ({ ...a, show: false }))} onHide={() => setModalFailedWa((a) => ({ ...a, show: false }))} theme={"danger"} title={"Failed"} text={modalFailedWa.message} />
    </>
  );
}
export default ResumeContent;
